(function( $, root ){

    $.fn.toggle_accordion = function () {
        if ( !this.hasClass('faq-topic') ) { return; }
        if ( this.hasClass('accordion-open') ) {
            this.removeClass('accordion-open');
            $('.faq-accordion-content', this).slideUp();
        } else {
            $('.faq-accordion-content', '.accordion-open').slideUp();
            $('.accordion-open').removeClass( 'accordion-open' );
            this.addClass('accordion-open');
            $('.faq-accordion-content', this).slideDown();
        }
    }

    $(document).on('click', '.faq-accordion-heading', function () {
        $(this).closest('.faq-topic').toggle_accordion();
    });

    $(function () {
        $('.accordion-open .faq-accordion-content').show();
    });

})(jQuery, this);